import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";

const SongItems = ({ id, title, cover, playSong }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState();

  const play = async () => {
    setIsLoading(true);
    await playSong(id, title);
    setIsLoading(false);
  };

  return (
    <div className="bg-white shadow  my-2 w-full h-full">
      <div className="relative " onClick={play}>
        {!imageLoaded && <Skeleton height={200} />}
        <img
          src={cover}
          alt={id}
          className="w-full object-cover  "
          onLoad={() => setImageLoaded("loaded")}
        />
      </div>
      {isLoading && (
        <div className="text-center">
          <span className="text-xl font-semibold italic text-pink-600">
            Playing...
          </span>
        </div>
      )}
      <div className="m-3">
        <h4 className="text-gray-600 md:text-lg text-xl ">{title}</h4>
      </div>
    </div>
  );
};

export default SongItems;
